import { EmployeeDto } from './employee.dto';
export class PosValidateStaffAccessResponseDto {
  isStaffAccess: boolean;
  priceChangeAccess: boolean;
  partialEmployee?: Pick<
    EmployeeDto,
    'id' | 'firstName' | 'lastName' | 'priceBracket'
  > | null;
}
